export var FulfilmentStoreStockLevelResponse;
(function (FulfilmentStoreStockLevelResponse) {
    FulfilmentStoreStockLevelResponse.StockLevelEnum = {
        InStock: 'InStock',
        LowStock: 'LowStock',
        NoStock: 'NoStock',
        Unknown: 'Unknown'
    };
})(FulfilmentStoreStockLevelResponse || (FulfilmentStoreStockLevelResponse = {}));
